import { handleActions } from 'redux-actions'
import { allById, allIds, customById } from 'lib/reducers'
import Actions from './actions'

export default handleActions(
  {
    [Actions.RECEIVE_LOCATIONS]: (state, { payload: locations }) => ({
      allById: allById(locations),
      allIds: allIds(locations),
      isVisibleById: customById(locations, true)
    }),
    [Actions.SHOW_LOCATION]: (state, { payload: id }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: true }
    }),
    [Actions.HIDE_LOCATION]: (state, { payload: id }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: false }
    }),
    [Actions.SHOW_ALL_LOCATIONS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = true
        return acc
      }, {})
    }),
    [Actions.HIDE_ALL_LOCATIONS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = false
        return acc
      }, {})
    })
  },

  { allIds: [], visibleIds: [], allById: {} }
)
